let browserHistory = require("react-router").browserHistory;
let connect = require("react-redux").connect;
let format = require("date-fns/format");
import React from "react";

let actions = require("../actions/actions");
let CreatorRating = require("./moderation-creator-rating");

class ModerationUploadSlat extends React.Component {
    getNoteStatus() {
        let noteStatus;

        if (this.props.upload.creator.important_note) {
            noteStatus = "red";
        } else {
            noteStatus = "yellow";
        }

        return noteStatus;
    }

    previewUpload(uploadId) {
        browserHistory.push(`/fort/modparty/creators/preview/${uploadId}/`);
    }

    render() {
        if (this.props.upload) {
            let noteStatusColor = this.getNoteStatus();

            return (
                <div className="navbar navbar-default">
                    <div className="creator-account-info navbar_header col-lg-3">
                        <div className="row">
                            <a
                                href={`/fort/members/${this.props.upload.creator.id}/`}
                                target="_blank"
                                className="profile avatar col-lg-3"
                            >
                                <div
                                    style={{
                                        backgroundImage: `url("${this.props.upload.creator.avatar}")`,
                                        borderRadius: "50%",
                                        width: "40px",
                                        height: "40px",
                                        backgroundSize: "40px"
                                    }}
                                />
                            </a>
                            <div className="creator-info col-lg-9">
                                <a
                                    href={`/fort/members/${this.props.upload.creator.id}/`}
                                    target="_blank"
                                >
                                    <div className="creator-name">
                                        {this.props.upload.creator.name}
                                    </div>
                                    <div className="creator-email gray">
                                        {this.props.upload.creator.email}
                                    </div>
                                </a>
                            </div>
                        </div>
                    </div>
                    <div className="col-lg-6 meta">
                        <div className="row">
                            <div className="rating col-lg-4">
                                <span className="gray">Rating</span>
                                <CreatorRating
                                    starRating={
                                        this.props.upload.creator.star_rating
                                    }
                                    iconRating={
                                        this.props.upload.creator.icon_rating
                                    }
                                />
                            </div>
                            <div className="uploads col-lg-4">
                                <span className="gray">Total uploads</span>
                                <input
                                    type="text"
                                    value={this.props.upload.icon_count}
                                    className="btn btn-default total-uploads"
                                    readOnly
                                />
                            </div>
                            <div className="saved-date col-lg-4">
                                <span className="gray">Uploaded</span>
                                <input
                                    type="text"
                                    value={format(
                                        new Date(this.props.upload.created_at),
                                        "MM/D/YY"
                                    )}
                                    className="btn btn-default date-uploaded"
                                    readOnly
                                />
                            </div>
                        </div>
                    </div>
                    <div className="col-lg-3 actions">
                        <div className="btn-group">
                            <button
                                type="button"
                                className={`btn btn-default ui_notes ${noteStatusColor}`}
                                onClick={this.viewNote.bind(this)}
                            >
                                Note
                            </button>
                            <button
                                type="button"
                                className="btn btn-default blue ui_eye"
                                onClick={this.previewUpload.bind(
                                    this,
                                    this.props.upload.id
                                )}
                            >
                                Preview
                            </button>
                            <button
                                type="button"
                                className="btn btn-default black"
                                onClick={this.reviewUpload.bind(this)}
                            >
                                Review
                            </button>
                        </div>
                    </div>
                </div>
            );
        } else {
            return null;
        }
    }

    reviewUpload() {
        this.props.showModal(null, "REVIEW_UPLOAD_CONFIRMATION", {
            saveForLater: false,
            upload: this.props.upload
        });
    }

    viewNote() {
        this.props.showModal(null, "VIEW_NOTES", { upload: this.props.upload });
    }
}

function mapStateToProps(state, ownProps) {
    let upload, keys;

    if (state.uploads.result) {
        if (state.uploadsNewSearchKeys.length > 0) {
            keys = state.uploadsNewSearchKeys;
        } else if (state.uploadsNewKeys.length > 0) {
            keys = state.uploadsNewKeys;
        }

        if (keys) {
            keys.forEach(uploadId => {
                if (ownProps.upload.id === uploadId) {
                    upload = state.uploads[uploadId];
                }
            });
        }
    }

    return { upload };
}

module.exports = connect(mapStateToProps, {
    showModal: actions.showModal
})(ModerationUploadSlat);
